export default class ContentExchangeToggle {
    constructor() {
        this.init();
    }

    init() {
        const filterContent = document.querySelector('.content-exchange__filter--header > span');
        const filterList = document.querySelector('.content-exchange__filter--list');

        if (filterContent && filterList) {
            filterContent.addEventListener('click', () => {
                filterList.classList.toggle('open');
            });
        }
    }
}

